<script setup lang="ts">
import { computed, defineProps } from 'vue';

const route = useRoute()

interface TextureOptions {
  image: string;
  attachment?: string;
  position?: string;
  opacity?: number;
  blendMode?: string;
}

const props = withDefaults(defineProps<{
  id: string;
  transition?: string;
  options: TextureOptions;
}>(), {
  id: '',
  transition: 'herooverlay',
  options: () => {
    return {
      image: '',
      attachment: 'scroll',
      position: 'center',
      opacity: 1,
      blendMode: 'overlay',
    }
  },
})

const textureStyle = computed(() => {
  const { image, attachment = 'scroll', position = 'center', opacity = 1, blendMode = 'overlay' } = props.options;
  if (!image) {
    return { display: 'none' };
  }
  return {
    backgroundImage: `url(${image})`,
    backgroundAttachment: attachment,
    backgroundPosition: position,
    backgroundSize: 'cover',
    opacity: opacity,
    mixBlendMode: blendMode,
  };
});
</script>

<template>
  <transition name="fade" mode="out-in" appear>
    <div class="io-hero-overlay texture" :key="route.path + id" :class="'hero-texture-' + id" :style="textureStyle" />
  </transition>
</template>

<style lang="scss" scoped>
.io-hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  
  &.texture {
    z-index: 2;
  }
}
</style>